import SwiperCarousel from 'utils/swiper-carousel';

export default (element) => {
  const el = element.querySelector('[data-blog-carousel]');

  if (!el) return;

  const MOBILE_BREAKPOINT = 768;
  let swiperInstance = null;
  const wrapper = el.querySelector('[data-blog-carousel-wrapper]');
  const slides = el.querySelectorAll('[data-blog-carousel-slide]');

  const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

  const initSwiper = () => {
    if (swiperInstance) return;

    el.classList.add('swiper');
    if (wrapper) wrapper.classList.add('swiper-wrapper');
    slides.forEach((slide) => slide.classList.add('swiper-slide'));

    const carousel = new SwiperCarousel(el, {
      slidesPerView: 1.4,
      spaceBetween: 20,
      slidesOffsetAfter: 40,
      allowTouchMove: true,
      navigation: {
        nextEl: element.querySelector('.next'),
        prevEl: element.querySelector('.prev'),
      },
    });

    swiperInstance = carousel.swiper;
  };

  const destroySwiper = () => {
    if (!swiperInstance) return;

    swiperInstance.destroy(true, true);
    swiperInstance = null;

    el.classList.remove('swiper');
    if (wrapper) wrapper.classList.remove('swiper-wrapper');
    slides.forEach((slide) => slide.classList.remove('swiper-slide'));
  };

  const handleResize = () => {
    if (isMobile()) {
      initSwiper();
    } else {
      destroySwiper();
    }
  };

  handleResize();

  window.addEventListener('resize', handleResize);
};
